import { render } from "./CtaButton.vue?vue&type=template&id=3eb8a523&scoped=true"
import script from "./CtaButton.vue?vue&type=script&lang=js"
export * from "./CtaButton.vue?vue&type=script&lang=js"

import "./CtaButton.vue?vue&type=style&index=0&id=3eb8a523&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb8a523"]])

export default __exports__